module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"field":{"total":"頭数合計"},"menu":{"pickup":"ピックアップ","tag":"タグ","close":"閉じる"}},"en":{"field":{"total":"Total"},"menu":{"pickup":"Select","tag":"Tag","close":"Close"}}}')
  delete Component.options._Ctor
}
